import { render, staticRenderFns } from "./CreateConsignment.vue?vue&type=template&id=1c4e2e69&scoped=true&"
import script from "./CreateConsignment.vue?vue&type=script&lang=ts&"
export * from "./CreateConsignment.vue?vue&type=script&lang=ts&"
import style0 from "./CreateConsignment.vue?vue&type=style&index=0&id=1c4e2e69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4e2e69",
  null
  
)

export default component.exports